@if (showRecurrenceOptions$ | async) {
<div id="order-recurrence">
  <fieldset class="mt-1">
    <legend class="sr-only">{{ 'order.recurrence.form.legend' | translate }}</legend>
    <input
      type="radio"
      id="order_recurrence_single"
      name="order_recurrence"
      value="single-order"
      class="form-check-input"
      [checked]="!recurrence()"
      (change)="updateOrderRecurrence(null)"
    />
    <label class="form-check-label" for="order_recurrence_single">{{
      'order.recurrence.single_order.label' | translate
    }}</label>
    <div class="mt-2">
      <input
        type="radio"
        id="order_recurrence_recurring"
        name="order_recurrence"
        value="recurring-order"
        class="form-check-input"
        [checked]="!!recurrence()"
        (change)="updateOrderRecurrence(defaultRecurrence)"
        data-testing-id="enable-recurring-order"
      />
      <label class="form-check-label" for="order_recurrence_recurring">{{
        'order.recurrence.recurring_order.label' | translate
      }}</label>
    </div>
    <ish-content-include includeId="include.basket.recurringorder.ordersummary.pagelet2-Include" />
  </fieldset>
  <div class="sr-only" aria-live="polite" role="text">
    {{
      (!!recurrence() ? 'order.recurrence.form.announcement.open' : 'order.recurrence.form.announcement.close')
        | translate
    }}
  </div>
  <div
    [ngbCollapse]="!recurrence()"
    id="order_recurrence_form"
    aria-labelledby="order_recurrence_recurring"
    class="mt-3"
  >
    <form [formGroup]="form">
      @if(fields.length&&model){
      <formly-form [form]="form" [fields]="fields" [model]="model" />
      }
    </form>
  </div>
</div>
}
